import * as PIXI from 'pixi.js-legacy'

PIXI.DisplayObject.prototype.getAbsolutePosition = function () {
  let x = 0
  let y = 0

  let el = this
  while (elementExists(el) && idNot(el, 'root', 'content')) {
    x += el.x - el.pivot.x
    y += el.y - el.pivot.y

    el = el.parent
  }

  return { x, y }
}

PIXI.DisplayObject.prototype.intersectsRect = function (rect) {
  const { x, y } = this.getAbsolutePosition()
  return !(
    rect.x > x + this.width ||
    rect.x + rect.width < x ||
    rect.y > y + this.height ||
    rect.y + rect.height < y
  )
}

const elementExists = (el) => Boolean(el && !el.destroyed)
const idNot = (el, ...ids) => ids.every((id) => id !== el?.id)
